module.exports = __webpack_public_path__ + "img/add.93827852.svg";